import * as Models from './'

export interface IGroupTypeModel {
    groupTypeId: string;
    code: string;
    name: string;
    description: string;
}

export class GroupTypeModel implements IGroupTypeModel {
    groupTypeId: string;
    code: string;
    name: string;
    description: string;
}